export function pushToDataLayer(event: string, data?: Record<string, unknown>): void {
    if (typeof window === 'undefined') {
        return;
    }

    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    window.dataLayer.push({
        event,
        ...data,
    });
}
